import { z } from 'zod';
export const BacklogBucket = z.object({
    id: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    color: z.string().nullable(),
    sortOrder: z.number(),
    queryText: z.string().nullable(),
    allowedTicketTypes: z.array(z.string()).nullable(),
    ownerId: z.string().nullable(),
    wipLimit: z.number().nullable(),
    active: z.boolean(),
    ticketCount: z.number().optional(),
});
export const CreateBacklogBucketInput = z.object({
    name: z.string().min(1),
    description: z.string().optional(),
    color: z.string().optional(),
    sortOrder: z.number().optional(),
    allowedTicketTypes: z.array(z.string()).optional(),
    wipLimit: z.number().nullable().optional(),
});
export const UpdateBacklogBucketInput = CreateBacklogBucketInput.partial().extend({
    active: z.boolean().optional(),
});
/** Move (or remove) a ticket's bucket assignment. */
export const MoveToBucketInput = z.object({
    backlogBucketId: z.string().nullable(),
    rank: z.string().optional(),
});
//# sourceMappingURL=backlog.js.map